import { FormGroup, FormControlLabel } from '@mui/material';
import classNames from 'classnames';
import { GMCheckbox } from '../..';
import css from './BaseCheckboxFormControl.module.scss';
import { GoMotoComponent } from '../../../../API/GoMoto.types';
import { BaseCheckboxFormControlProps } from './BaseCheckboxFormControl.types';

/**
 * Checkbox styled like a form control
 */
export const BaseCheckboxFormControl: GoMotoComponent<BaseCheckboxFormControlProps> = ({
    label,
    variant,
    color = 'dark',
    padding = 'normal',
    labelPlacement = 'end',
    errorClassName,
    ...baseProps
}) => {
    return (
        <FormGroup
            className={classNames(
                css.formGroup,
                {
                    [css.outlined]: variant === 'outlined',
                    [css.standard]: variant === 'standard',
                    [css.light]: color === 'light',
                    [css.dark]: color === 'dark',
                    [css.normalPadding]: padding === 'normal',
                    [css.noPadding]: padding === 'none',
                    [css.densePadding]: padding === 'dense',
                    [css.sidesPadding]: padding === 'sides',
                    [css.overflowLabel]: baseProps.overflowLabel,
                },
            )}
        >
            <FormControlLabel
                control={
                    <GMCheckbox
                        {...baseProps}
                        color={color}
                    />
                }
                label={label}
                disabled={baseProps.disabled}
                className={classNames(css.label, {
                    [css.disabled]: baseProps.disabledButClickable,
                    [css.overflowLabel]: baseProps.overflowLabel,
                    [css.smallerLabel]: baseProps.smallerLabel,
                })}
                classes={{
                    error: errorClassName,
                }}
                labelPlacement={labelPlacement}
            />
        </FormGroup>
    );
};